import { KbSolution } from "@/sharedTypes";
import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const kbSolutionTag = "KbSolution";

const kbSolutionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getKbSolutions: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const queryString = params
          ? new URLSearchParams(flattenQueryParams(params)).toString()
          : "";
        return `/gw/kb-solutions${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [kbSolutionTag],
    }),
    getKbSolutionById: builder.query<any, number>({
      query: (id) => `/gw/kb-solutions/${id}`,
      providesTags: (result, error, id) => [{ type: kbSolutionTag, id }],
    }),
    createKbSolution: builder.mutation<KbSolution, Partial<KbSolution>>({
      query: (data) => ({
        url: `/gw/kb-solutions`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [kbSolutionTag],
    }),
    updateKbSolution: builder.mutation<KbSolution, { id: number } & Partial<KbSolution>>({
      query: ({ id, ...data }) => ({
        url: `/gw/kb-solutions/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        kbSolutionTag,
        { type: kbSolutionTag, id },
      ],
    }),
    deleteKbSolution: builder.mutation<void, number>({
      query: (id) => ({
        url: `/gw/kb-solutions/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [kbSolutionTag],
    }),
  }),
});

export const {
  useGetKbSolutionsQuery,
  useGetKbSolutionByIdQuery,
  useCreateKbSolutionMutation,
  useUpdateKbSolutionMutation,
  useDeleteKbSolutionMutation,
} = kbSolutionApi;
